import RecruitmentComponent from '../RecruitmentComponent.vue'

export default [
    {
        path: '/recruitment',
        name: 'Recruitment',
        meta: { layout: 'default', requiresRecruitmentAccess: true },
        component: RecruitmentComponent,
    },
]
